import { useRouter } from 'next/router'

export default function useExpressDealModal() {
  const router = useRouter()
  const { query, pathname } = router
  const isOpen = query.modal === 'express-deals'
  const openModal = () => {
    router.push(`${pathname}?modal=express-deals`, undefined, { shallow: true })
  }
  const closeModal = () => {
    router.push(pathname, undefined, { shallow: true })
  }
  return { isOpen, openModal, closeModal }
}
